import {
  Button,
  Flex,
  Paper,
  Text,
  Loader,
  TextInput,
  Checkbox,
  Group,
} from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../hooks";
import { RootState } from "../store";
import {
  displayErrorMessage,
  displayServerErrorMessage,
} from "../shared/ErrorMessage";
import { initialize, updateField } from "../slices/form/cloneVent";
import { useEffect } from "react";
import { CloneVentRequest, useCloneVentMutation } from "../slices/api/ventsApi";
import { DateTimePicker } from "@mantine/dates";
import { convertToIso8601WithLocalTimezone } from "../shared/dates";

interface Props {
  ventId: string;
  ventName: string;
  ventStarts: string;
  onClose: () => void;
}
const CloneVent = (props: Props) => {
  const { data } = useAppSelector((state: RootState) => state.cloneVentForm);
  const [cloneVent] = useCloneVentMutation();
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
      initialize({
        cloneGuests: false,
        cloneActivities: false,
        name: "CLONE of " + props.ventName,
        starts: props.ventStarts,
      }),
    );
  }, []);

  const handleClone = async (ventId: string) => {
    if (ventId == null || data == null) {
      console.error("undefined");
      return;
    }

    if (data.name == null) {
      displayErrorMessage("Name is required.");
      return;
    }

    const request: CloneVentRequest = {
      ventId: ventId,
      cloneGuests: data.cloneGuests,
      cloneActivities: data.cloneActivities,
      starts: data.starts,
      name: data.name,
    };

    try {
      await cloneVent(request).unwrap();
      props.onClose();
    } catch (error) {
      displayServerErrorMessage(error);
    }
  };

  if (!data) {
    return <Loader color="blue" />;
  }

  return (
    <>
      <Paper>
        <Text size="lg">{`Clone ${props.ventName}`}</Text>
        <TextInput
          required
          mt="md"
          label="Name"
          style={{ width: "300px" }}
          value={data.name ?? ""}
          onChange={(v) => {
            dispatch(
              updateField({
                field: "name",
                value: v.currentTarget.value,
              }),
            );
          }}
        />
        <DateTimePicker
          timePickerProps={{ format: "12h" }}
          required
          mt="md"
          label="Starts at"
          placeholder="Pick start date and time"
          valueFormat="DD MMM YYYY hh:mm A"
          value={new Date(data.starts)}
          onChange={(event) => {
            dispatch(
              updateField({
                field: "starts",
                value:
                  convertToIso8601WithLocalTimezone(event ?? undefined) ??
                  data.starts,
              }),
            );
          }}
        />
        <Group mt="lg">
          <Checkbox
            label={`Copy activities`}
            checked={data.cloneActivities}
            onChange={(event) =>
              dispatch(
                updateField({
                  field: "cloneActivities",
                  value: event.currentTarget.checked,
                }),
              )
            }
          />
          <Checkbox
            label={`Copy guests`}
            checked={data.cloneGuests}
            onChange={(event) =>
              dispatch(
                updateField({
                  field: "cloneGuests",
                  value: event.currentTarget.checked,
                }),
              )
            }
          />
        </Group>
        <Flex justify="flex-end">
          <Button mt="md" mr="md" onClick={props.onClose}>
            Cancel
          </Button>
          <Button mt="md" onClick={() => handleClone(props.ventId)}>
            Clone
          </Button>
        </Flex>
      </Paper>
    </>
  );
};

export default CloneVent;
